// components/ui/RowMoreButton.tsx
import React from 'react';
import clsx from 'clsx';
import { MoreHorizontal } from '@/components/ui/lucide-memo';

// ChatGPT's row '...': a round ghost button that shows when its row (a `group`) is hovered or the
// button has keyboard focus. One definition for every list and tile that carries a row menu.
export function RowMoreButton({ onClick, label = 'More', className }: {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  label?: string;
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className={clsx(
        'flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-[#B4B4B4] opacity-0 transition-[opacity,background-color] hover:bg-white/[0.08] hover:text-white focus-visible:opacity-100 group-hover:opacity-100',
        className,
      )}
    >
      <MoreHorizontal size={18} />
    </button>
  );
}
